/* Koukita – n'affiche que les photos de la couleur choisie (thème Sense).
   Les photos dont le texte alternatif finit par « – <Couleur du produit> » sont filtrées ;
   les photos sans couleur reconnue restent toujours visibles. */
(function () {
  var SEP = ' – ';
  function norm(s) { return (s || '').toString().trim().toLowerCase(); }
  function colorOf(li, colors) {
    var img = li.querySelector('img[alt]');
    if (!img) return '';
    var alt = norm(img.getAttribute('alt'));
    var parts = alt.split(SEP);
    var last = norm(parts[parts.length - 1]);
    if (!colors || colors.indexOf(last) > -1) return last;
    // Couleur citée n'importe où dans le texte alternatif (la plus longue gagne)
    var best = '';
    (colors || []).forEach(function (c) {
      if (!c || c.length <= best.length) return;
      var i = alt.indexOf(c);
      while (i > -1) {
        var before = i === 0 ? ' ' : alt.charAt(i - 1);
        var after = alt.charAt(i + c.length) || ' ';
        if (!/[a-z0-9\u00e0-\u00ff]/.test(before) && !/[a-z0-9\u00e0-\u00ff]/.test(after)) { best = c; break; }
        i = alt.indexOf(c, i + 1);
      }
    });
    return best || last;
  }

  // Photos rattachées aux variantes : couleur -> ids des médias (automatique pour tout nouveau produit)
  function variantMediaMap(picker, index) {
    var map = {};
    if (!picker) return map;
    var data = [];
    try {
      data = typeof picker.getVariantData === 'function'
        ? picker.getVariantData()
        : JSON.parse(picker.querySelector('[type="application/json"]').textContent);
    } catch (e) { data = []; }
    (data || []).forEach(function (v) {
      if (!v || !v.featured_media || !v.options) return;
      var c = norm(v.options[index]);
      (map[c] = map[c] || {})[String(v.featured_media.id)] = true;
    });
    return map;
  }
  function mediaIdOf(li) {
    var id = li.dataset.mediaId || li.dataset.target || '';
    return id.split('-').pop();
  }

  function applyFilter(gallery, selected, map) {
    var colors = (gallery.dataset.kkColors || '').split('|').map(norm);
    selected = norm(selected);
    map = map || {};
    gallery.querySelectorAll('.product__media-list > li, .thumbnail-list > li').forEach(function (li) {
      var hide = false;
      if (selected !== '') {
        var c = colorOf(li, colors);
        if (colors.indexOf(c) > -1) {
          hide = c !== selected;
        } else {
          var id = mediaIdOf(li);
          var mine = map[selected] && map[selected][id];
          var other = Object.keys(map).some(function (k) { return k !== selected && map[k][id]; });
          hide = !mine && other;
        }
      }
      li.classList.toggle('kk-hidden', hide);
    });

    var viewer = gallery.querySelector('.product__media-list');
    var active = viewer && viewer.querySelector('li.is-active');
    if (active && active.classList.contains('kk-hidden') && typeof gallery.setActiveMedia === 'function') {
      var first = viewer.querySelector('li:not(.kk-hidden)[data-media-id]');
      if (first) gallery.setActiveMedia(first.dataset.mediaId, false);
    }
    gallery.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  function selectedColor(picker, index) {
    if (picker && picker.currentVariant && picker.currentVariant.options) {
      return picker.currentVariant.options[index];
    }
    if (!picker) return '';
    var groups = picker.querySelectorAll('.product-form__input');
    var group = groups[index];
    if (!group) return '';
    var checked = group.querySelector('input:checked');
    if (checked) return checked.value;
    var select = group.querySelector('select');
    return select ? select.value : '';
  }

  function updateLegend(picker, index, value) {
    if (!picker) return;
    var group = picker.querySelectorAll('.product-form__input')[index];
    var label = group && group.querySelector('.kk-selected-value');
    if (label && value) label.textContent = ' : ' + value;
  }

  function init() {
    document.querySelectorAll('media-gallery[data-kk-color-filter]').forEach(function (gallery) {
      if (gallery.dataset.kkReady) return;
      gallery.dataset.kkReady = 'true';
      var sectionId = gallery.id.replace('MediaGallery-', '').replace('-duplicate', '');
      var index = parseInt(gallery.dataset.kkColorIndex, 10) || 0;
      var picker = document.querySelector(
        'variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]'
      );
      var map = variantMediaMap(picker, index);
      applyFilter(gallery, gallery.dataset.kkSelected || selectedColor(picker, index), map);
      if (!picker) return;
      picker.addEventListener('change', function () {
        window.setTimeout(function () {
          var value = selectedColor(picker, index);
          updateLegend(picker, index, value);
          document.querySelectorAll('media-gallery[data-kk-color-filter][id^="MediaGallery-' + sectionId + '"]')
            .forEach(function (g) { applyFilter(g, value, map); });
        }, 0);
      });
    });
  }

  // Pastilles au-dessus d'une liste déroulante : on change la liste et on prévient le thème
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.kk-swatch-btn') : null;
    if (!btn) return;
    var group = btn.closest('.product-form__input');
    var select = group && group.querySelector('select');
    if (!select) return;
    select.value = btn.dataset.kkValue;
    group.querySelectorAll('.kk-swatch-btn').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var label = group.querySelector('.kk-selected-value');
    if (label) label.textContent = ' : ' + btn.dataset.kkValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
